import {Directive, TemplateRef, ViewContainerRef, OnDestroy, OnInit, Input} from "@angular/core";
import {AppSettingsService} from "./app-settings.service";
import {Subscription} from "rxjs";
import {AppSettingsModel} from "./app-settings.model";

/**
 * This class toggles child element based on a setting (boolean evaluation).
 * It subscribes to AppSettingsService.
 * Based on [ngIf]: https://github.com/angular/angular/blob/2.2.x/modules/%40angular/common/src/directives/ng_if.ts
 */
@Directive({
  selector: "[appSetting]",
})
export class AppSettingDirective implements OnInit, OnDestroy {
  private setting: string;
  private subscription: Subscription;
  private hasView: boolean = false;
  private settings: AppSettingsModel;

  private update(settings?: AppSettingsModel) {
    if (settings) this.settings = settings;

    if (!this.settings) return;
    if (!this.setting) return;

    const invert = this.setting && this.setting[0] === "~";
    const setting = invert ? this.setting.substring(1) : this.setting;

    let condition = Boolean(this.settings[setting]);
    if (invert) condition = !condition;

    if (condition && !this.hasView) {
      this.hasView = true;
      this.viewContainer.createEmbeddedView(this.template);
    } else if (!condition && this.hasView) {
      this.hasView = false;
      this.viewContainer.clear();
    }
  }

  @Input()
  public set appSetting(v: string) {
    this.setting = v;
    this.update();
  }

  public get appSetting(): string {
    return this.setting;
  }

  ngOnInit(): void {
    if (this.subscription) return;
    this.subscription = this.appSettingsService.settings.subscribe(settings => this.update(settings));
  }

  ngOnDestroy(): void {
    if (!this.subscription) return;
    this.subscription.unsubscribe();
    this.subscription = undefined;
  }

  constructor(
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private appSettingsService: AppSettingsService,
  ) {
  }
}
